"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestAnimationFrame = exports.isEnter = exports.cancelAnimationFrame = void 0;

var requestAnimationFrame = function requestAnimationFrame(fn) {
  for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    rest[_key - 1] = arguments[_key];
  }

  if (window && {}.hasOwnProperty.call(window, 'cancelAnimationFrame')) {
    var _window;

    (_window = window).requestAnimationFrame.apply(_window, [fn].concat(rest));
  } else {
    fn.apply(void 0, rest);
  }
};

exports.requestAnimationFrame = requestAnimationFrame;

var cancelAnimationFrame = function cancelAnimationFrame() {
  if (window && {}.hasOwnProperty.call(window, 'cancelAnimationFrame')) {
    var _window2;

    (_window2 = window).cancelAnimationFrame.apply(_window2, arguments);
  }
};

exports.cancelAnimationFrame = cancelAnimationFrame;

var isEnter = function isEnter(props) {
  return props.animation.indexOf('enter') !== -1;
};

exports.isEnter = isEnter;
//# sourceMappingURL=animationUtils.js.map